import { authHttpClient } from '~/app/core/infra/http/axios-auth-http-client-adapter';

import { ServiceCommand } from '../../../../../core/domain/command/service-command';
import { AUTH_API_ROUTES } from '../../api/routes';
import { UpdateSubscription } from './update-subscription';

export const updateSubscriptionService: ServiceCommand<UpdateSubscription.Response> =
  new UpdateSubscription(authHttpClient, AUTH_API_ROUTES.UPDATE_SUBSCRIPTION);

export type { UpdateSubscription };
